import React from 'react'

const ArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="12.002" viewBox="0 0 18 12.002">
	  <path d="M12738.242,24381l-3.838-6,10.1,6-10.1,6Zm-4.462,1v-2h2.074v2Zm-3.636,0v-2h2.075v2Zm-3.636,0v-2h2.075v2Z" transform="translate(-12726.509 -24375.002)" fill={props.fill}/>
	</svg>
)

export default ArrowIcon